import styled from "styled-components";

function circleMap() {
  let style = "";

  let scale = 2; // scale

  let miniScale = 1;

  let opa = 1; //opacity

  for (let i = 1; i <= 3; i++) {
    style += `
    .circle${i} {
      &::after {
        content: url('Ellipse.svg');
        position: absolute;
        top: 167px;
        left: 0;
        opacity: ${opa};
        right: 165px;
        bottom: 0;
        scale: ${scale};
        z-index: -5;
        @media (max-width: 1150px) {
          top: 103px;
          right: 110px;
        }
        @media (max-width: 1050px) {
          top: 107px;
          right: 106px;
        }
        @media (max-width: 1024px) {
          top: 101px;
          right: 75px;
        }
        @media (max-width: 850px) {
          top: 116px;
          right: 108px;
        }
        @media (max-width: 600px) {
          top: -21px;
          right: -19px;
          scale: ${miniScale};
        }
        @media (max-width: 480px) {
          // display: none;
        }
      }
    }
    `;
    scale += 0.4;
    miniScale += 0.3;
    opa -= 0.25 * i;
  }
  return style;
}

export const PanelContainer = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 11rem;
  @media (max-width: 850px) {
    flex-direction: column-reverse;
    width: 100%;
    align-items: center;
  }
`;

export const VideoContainer = styled.div`
  width: 582px;
  display: flex;
  position: relative;
  height: 582px;
  margin-left: 150px;
  ${circleMap()};
  img {
    width: 100%;
    display: block;
    height: auto;
  }
  @media (max-width: 1150px) {
    width: 500px;
    height: 500px;
  }
  /* @media (max-width: 850px) {
    width: 400px;
    height: 400px;
  } */
  @media (max-width: 600px) {
    width: 294px;
    height: 294px;
    margin: 0 auto;
  }
  @media (max-width: 480px) {
    margin-top: 3rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 65%;
  width: 80px;
  height: 80px;
  @media (max-width: 600px) {
    top: 60%;
    left: 82%;
  }
  /* left: 85%; */
`;
export const ButtonWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: var(--primary-color);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img {
    width: 100%;
    margin-left: 5px;
  }
  @media (max-width: 600px) {
    width: 45px;
    height: 45px;
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-top: 0.8rem;
  /* margin-bottom: 6.3rem; */
  p {
    font-weight: 400;
    font-family: Peyda;
    font-size: 1.8rem;
    line-height: 3.2rem;
    text-align: justify;
    margin-bottom: 5.8rem;
    color: var(--title-color);
    @media (max-width: 850px) {
      font-size: 1.6rem;
    }
  }
  @media (max-width: 1024px) {
    width: ${(props) => props.width1024 || "100%"};
    p {
      margin-bottom: 5rem;
    }
  }
  @media (max-width: 850px) {
    p {
      margin-bottom: 2rem;
    }
  }
  @media (max-width: 600px) {
    width: ${(props) => props.width600 || "100%"};
    height: ${(props) => props.height600 || "96px"};
    margin-bottom: 3.2rem;
  }
  @media (max-width: 580px) {
    height: ${(props) => props.height600 || "130px"};
    margin-bottom: 3.5rem;
  }
`;

export const TitleContainer = styled.div`
  width: ${(props) => props.width};
  position: relative;
  /* margin-top: 10rem; */
  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: var(--span-color);
    margin-bottom: 1.2rem;
    font-family: Peyda;
    @media (max-width: 600px) {
      font-size: 1.6rem;
    }
  }
  h4 {
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 5.6rem;
    font-family: Peyda;
    padding-right: 1.4rem;
    color: var(--title-color);
    @media (max-width: 850px) {
      font-size: 2.6rem;
      margin-right: 5px;
    }
    @media (max-width: 600px) {
      font-size: 2.2rem;
    }
  }
  @media (max-width: 1150px) {
    width: ${(props) => props.width1150 || "45%"};
    margin-right: 20px;
  }
  @media (max-width: 1050px) {
    margin-top: 20px;
  }
  @media (max-width: 850px) {
    width: 100%;
    & button {
      width: 132px;
      height: 42px;
      margin-top: 3.2rem;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    & button {
      margin-top: 66px;
    }
  }
`;
